/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationNeedsQuery = gql`
  query GetSimulationNeedsQuery {
    getSimulationNeeds_simulation_needs {
      offer {
 code  
}
      subscriberNeeds {
 id  
healthNeeds {
 name  
level  
} 
}
      displayIsEnforcedGuarantee 
      contractOnGoing 
      collectionNeeds {
 budget  
protectionNeeds {
 code  
} 
isEnforcedGuarantee  
}
      companies {
 ccnHasAgreement  
}
      comment 
    }
  }
`;

export default GetSimulationNeedsQuery;
